import { FunctionComponent } from 'react';
import PreferencesForm from '../../../../components/forms/PreferencesForm/PreferencesForm';

interface DinningPreferencesProps {}

const DinningPreferences: FunctionComponent<DinningPreferencesProps> = () => {
  return <PreferencesForm visualType="two" />;
};

export default DinningPreferences;
